import { FC } from "react";
import { InfoCircle } from "untitledui-js-base";
import { toMoney } from "utils/currency";
import { formatDate } from "views/applications-id-report/utils";

type Props = {
  title: string;
  changes: {
    date: string;
    originalValue: string;
    changedBy: string;
  } | null;
};

export const VerifiedIncomeChangeInfoBanner: FC<Props> = ({
  changes,
  title
}) => {
  return (
    <div className="flex gap-4 items-center border-b border-alpha-100 pb-6 mb-6">
      <InfoCircle size="20" className="stroke-content-100" />
      <div>
        <p className="text-content-400 text-sm font-medium">
          {title} was edited by{" "}
          <span className="text-content-1000">
            {changes?.changedBy || "Unknown"}
          </span>{" "}
          on{" "}
          <span className="text-content-1000">{formatDate(changes?.date)}</span>
        </p>
        <p className="text-content-400 text-sm">
          Original value: {toMoney(changes?.originalValue as string)}
        </p>
      </div>
    </div>
  );
};
